import type { ZoomTransitionEnablerProps } from './ZoomTransitionEnabler.types';

export function disableZoomTransition() {}

export function isZoomTransitionEnabled() {
  return false;
}

export function ZoomTransitionEnabler(props: ZoomTransitionEnablerProps) {
  return null;
}
